import { i18n } from './i18n/index'
import App from './App.vue'
import { ViteSSG } from 'vite-ssg'
import type { RouteRecordRaw } from 'vue-router'
import routes from '@/router/routes'
import store from '@/store'
import { createHead } from '@vueuse/head'
import SectionTitle from '@/views/components/misc/SectionTitle.vue'

export const createApp = ViteSSG(
  App,
  { 
    routes: routes as RouteRecordRaw[],
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      
      if (to.hash) {
        return {
          el: to.hash,
          behavior: 'smooth',
          top: 100,
        }
      }
      
      return { top: 0 }
    },
  },
  ({ app, router, initialState, head }) => {
    // Install plugins
    app.use(store)
    app.use(i18n)
    // Register global components
    app.component('SectionTitle', SectionTitle)
    
    // vite-ssg provides head automatically if @vueuse/head is installed
    // No need to create it manually
    if (!head) {
      const headInstance = createHead()
      app.use(headInstance)
    }

    // Add router beforeEach hook
    import('./router/beforeEach').then(({ beforeEach }) => {
      router.beforeEach(beforeEach)
    })

    // Add error handler
    router.onError((error, to) => {
      if (
        error.message.includes('Failed to fetch dynamically imported module') ||
        error.message.includes('Importing a module script failed') ||
        error.message.includes('Unable to preload CSS')
      ) {
        if (typeof window !== 'undefined') {
          window.location.href = to.fullPath
        }
      }
    })
  }
)
